@import '../../theme/global';

snap-auth-input {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  @include set-font;
  @include box-sizing;

  input {
    border-style: solid;
    color: inherit;
    font-family: inherit;
    font-size: 100%;
    line-height: inherit;
    margin: 0;
    padding: 0;
  }

  .snap-auth-input-label-container {
    display: flex;
    justify-content: space-between;
    max-width: 290px;
    width: 100%;
  }

  .required {
    color: $red-500;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-left: 0.25rem;
  }

  .snap-auth-input-label {
    color: $gray-700;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    margin-bottom: 0.25rem;
  }

  .snap-auth-input-label-corner {
    color: $gray-500;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    margin-bottom: 0.25rem;
  }

  .snap-auth-input-container {
    align-items: center;
    display: flex;
    justify-content: center;

    &.error {
      .snap-auth-input {
        border-color: $red-500;
      }
    }

    &.success {
      .snap-auth-input {
        border-color: $green-500;
      }
    }

    .snap-auth-input {
      background-color: $base-light;
      border-color: $gray-300;
      border-radius: 0.625rem;
      border-width: 1px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      color: $gray-800;
      height: 42px;
      margin-right: 0.625rem;
      text-align: center;
      width: 40px;

      &:last-child {
        margin-right: 0;
      }

      &:focus-visible,
      &:focus {
        outline: $blue-600 auto 1px;
      }

      &[disabled] {
        background-color: $gray-100;
      }
    }
  }

  .snap-auth-input-label-text {
    &.helper {
      color: $gray-500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      margin-top: 0.25rem;
    }

    &.error {
      color: $red-600;
      font-size: 0.875rem;
      line-height: 1.25rem;
      margin-top: 0.25rem;
    }

  }

  .snap-auth-input-label-helper-link {
    margin-top: 0.25rem;

    button.snap-button {
      background-color: transparent;
      border-width: 0;
      box-shadow: none;
      color: $blue-600;
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5rem;
      padding: 0;

      &:focus {
        box-shadow: none;
        outline: 0;
      }

      &:active {
        box-shadow: none;
      }
    }
  }
}
